import React, {useState, useEffect, useContext, useCallback} from 'react';
import useKeyPress from '../../../hooks/useKeyPress';
import FullBodyMenuView from '../../views/fullBodyMenuView';
import {timeZoneItem} from '../../../App';
import TimeDate from './time-date';
import {useMenu} from '../../../hooks/useMenu';
import TimeZoneTN from './time-zoneTN';
import CommandsContext from '../../../context/commandsContext';

function TimeZone({initiallyDisableKeypress}) {
  const [isKeypressDisabled, setIsKeypressDisabled] = useState(initiallyDisableKeypress);
  const leftPress = useKeyPress('ArrowLeft');
  const rightPress = useKeyPress('ArrowRight');
  const {onComponent} = useMenu();
  const {onUpdateCommands} = useContext(CommandsContext);

  useEffect(() => {
    if (!leftPress || isKeypressDisabled) return;

    // onComponent(<TimeDate />);
  }, [leftPress]);

  useEffect(() => {
    if (!rightPress || isKeypressDisabled) return;

    // onComponent(<TimeZOneTN />);
  }, [rightPress]);

  const onRight = useCallback(() => {
    onComponent(<TimeZoneTN />);
  }, []);

  useEffect(() => {
    onUpdateCommands(commands => ({...commands, onRight}));
  }, []);

  // useEffect(() => {
  //   if (!initiallyDisableKeypress) return;

  //   setTimeout(() => {
  //     setIsKeypressDisabled(false);
  //   }, 500);
  // }, []);

  return (
    <FullBodyMenuView
      title="Select Time Zone"
      menuItems={timeZoneItem}
      isMenuDisabled
      onLeftCallback={() => onComponent(<TimeDate />)}
      onRightCallback={onRight}
    />
  );
}
export default TimeZone;
